<mat-spinner
  aria-label="Loading.."
  diameter="90"
  strokeWidth="6"
  class="rkt-ProgressSpinner"
></mat-spinner>
